import { render, staticRenderFns } from "./BUploadFileV2.vue?vue&type=template&id=f949fdaa&scoped=true&"
import script from "./BUploadFileV2.vue?vue&type=script&lang=js&"
export * from "./BUploadFileV2.vue?vue&type=script&lang=js&"
import style0 from "./BUploadFileV2.vue?vue&type=style&index=0&id=f949fdaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f949fdaa",
  null
  
)

export default component.exports